'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import Raven from 'raven-js';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class AsyncComponentLoading extends Component {
  constructor(props) {
    super(props);
    this.state = {
      retriesLeft: 2
    };
    this.handleRetry = this.handleRetry.bind(this);
  }
  handleRetry() {
    if (this.state.retriesLeft > 0) {
      this.props.retry();
      this.setState(({
        retriesLeft
      }) => {
        return {
          retriesLeft: retriesLeft - 1
        };
      });
      return;
    }
    Raven.captureMessage('All retries exhausted');
    setTimeout(window.location.reload, 250);
  }
  render() {
    const {
      pastDelay,
      error
    } = this.props;
    if (error) {
      return /*#__PURE__*/_jsxs(Text, {
        textAlign: "center",
        marginBlockStart: "500",
        children: [/*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "login.asyncComponent.error"
          })
        }), /*#__PURE__*/_jsx(Button, {
          use: "primary",
          onClick: this.handleRetry,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "login.asyncComponent.reload"
          })
        })]
      });
    }
    if (pastDelay) {
      return /*#__PURE__*/_jsx(LoadingSpinner, {
        marginBlockStart: "500",
        grow: true
      });
    }
    return null;
  }
}
AsyncComponentLoading.propTypes = {
  error: PropTypes.string,
  retry: PropTypes.func,
  pastDelay: PropTypes.bool
};